import { render, staticRenderFns } from "./LecturerInfo.vue?vue&type=template&id=4f82b3e5"
import script from "./LecturerInfo.vue?vue&type=script&lang=js"
export * from "./LecturerInfo.vue?vue&type=script&lang=js"
import style0 from "./LecturerInfo.vue?vue&type=style&index=0&id=4f82b3e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports